// We use cloudfront to map givelaud.com/awardimages to the laudawards S3
// bucket and directly into the awardimages folder. We do the same for
// templates.

const ProdDomain = import.meta.env.VITE_DOMAIN || 'https://www.givelaud.com';
const AppName = 'Laud';
const ArweaveDomain = 'https://arweave.net';
const ArweaveBlockExplorer = 'https://arscan.io/tx';
const AwardBucketName = import.meta.env.VITE_AWARD_BUCKET_NAME || 'laudawards';
const AwardLogoPath = `${ProdDomain}/logoImages/vajH3fdnRPQoTjR4XqNHk.png`;
const AwardImagePath = 'awardimages/';
const AwardPath = `${ProdDomain}/awardimages/`;
const CompanyName = 'Erdos Labs';
const Domain = process.env.NODE_ENV !== 'development'
    ? ProdDomain : `http://${window.location.host}`;
const EmailPath = `https://${AwardBucketName}.s3.amazonaws.com/emailimages/`;
const LogoImagePath = 'logoImages/';
const LogoPath = `${ProdDomain}/logoImages/`;
const MediaPath = `${ProdDomain}/static/media/`;
const SplinesPath = `${ProdDomain}/splines/`;

export {
    AppName,
    ArweaveBlockExplorer,
    ArweaveDomain,
    AwardBucketName,
    AwardImagePath,
    AwardLogoPath,
    AwardPath,
    CompanyName,
    Domain,
    EmailPath,
    LogoImagePath,
    LogoPath,
    MediaPath,
    SplinesPath,
};
